<template>
    <div>
        <template v-if="mode == 'edit'">
            <el-time-select
                v-if="hourformat === '24'"
                :ref="reference"
                v-model="currentValue"
                :placeholder="$t.__('common.labels.hour')"
                :pickerOptions="selectOptions"
            >
            </el-time-select>
            <el-time-picker
                v-if="hourformat === '12'"
                :ref="reference"
                v-model="currentValue"
                :placeholder="$t.__('common.labels.hour')"
                valueFormat="HH:mm A"
                format="HH:mm A"
                :pickerOptions="pickerOptions"
            >
            </el-time-picker>
        </template>
        <p v-else>
            {{ currentValue }}
        </p>
    </div>
</template>

<script>
import CfMixin from '../../../mixins/CustomfieldInputsMixins';
import { createNamespacedHelpers } from 'vuex';

const corpMapState = createNamespacedHelpers('corp').mapState;

export default {
    mixins: [CfMixin],
    emits: ['update:modelValue'],
    data() {
        return {
            localValue: this.value,
            currentValue: '',
            selectOptions: {
                start: this.prop.min != '' ? this.prop.min : '00:00',
                step: '00:01',
                end: this.prop.max != '' ? this.prop.max : '23:59',
            },
            pickerOptions: {
                format: 'HH:mm A',
                selectableRange: `${
                    this.prop.min.length
                        ? moment(this.prop.min.toUpperCase(), 'hh:mm A').format('HH:mm:ss')
                        : '00:00:00'
                } - ${
                    this.prop.max.length
                        ? moment(this.prop.max.toUpperCase(), 'hh:mm A').format('HH:mm:ss')
                        : '23:59:00'
                }`,
            },
        };
    },
    computed: {
        ...corpMapState(['hourformat']),
    },
    watch: {
        currentValue(newValue) {
            let stringValue = null;
            if (newValue !== null) {
                stringValue =
                    this.hourformat === '12'
                        ? moment(newValue, 'hh:mm A').format('h:mm A').toLowerCase()
                        : newValue;
            }
            // On AM/PM format, format hour 05 AM to 5 am for API.
            const updatedValue = {
                ...this.localValue,
                stringValue: stringValue,
            };
            this.$emit('update:modelValue', updatedValue);
        },
        value: {
            handler: function (newValue) {
                this.localValue = newValue;
                this.currentValue = newValue.stringValue;
            },
            deep: true,
        },
    },
    created() {
        if (!this.localValue) {
            this.localValue = JSON.parse(JSON.stringify(this.templateData));
        } else {
            this.currentValue = this.value.stringValue;
        }
    },
};
</script>
